var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 96.856,
    viewBox: "0 0 170 96.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359",
    transform: "translate(-79.145 -108.434)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "MECHANICAL_C_T",
    "data-name": "MECHANICAL C & T",
    transform: "translate(79.145 188.24)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MECHANICAL C &amp; T")), /*#__PURE__*/React.createElement("text", {
    id: "C_O_N_S_T_R_U_C_T_I_O_N_T_R_A_D_I_N_G_S_E_R_V_I_C_E_S",
    "data-name": "C O N S T R U C T I O N  &  T R A D I N G  S E R V I C E S",
    transform: "translate(79.145 203.29)",
    fill: "#fff",
    fontSize: 5,
    fontFamily: "Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "C O N S T R U C T I O N  &amp;  T R A D I N G  S E R V I C E S")), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(118.606 108.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M48.77,301.758h0v20.784c0,.948.351,1.4,1.369,1.334a18.308,18.308,0,0,1,2.774,0c1.088.07,1.4-.421,1.4-1.4v-41.5a1.286,1.286,0,0,0-1.4-1.439H50.736c-1.931-.035-1.966,0-1.966,1.9Z",
    transform: "translate(30.047 -272.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M26.355,277.515c1.4,0,2.809.07,4.213,0a4.311,4.311,0,0,1,4.108,2.387l17.484,28.753a5.135,5.135,0,0,0,.527.7c4.388-6.916,8.742-13.727,13.1-20.573a.268.268,0,0,1,.176.07c-.632,3.686-1.4,7.373-1.9,11.059a18.259,18.259,0,0,1-2.879,7.408c-2.7,4.388-5.266,8.882-7.9,13.341-.211.386-.456.737-.772,1.229-6.881-11.726-13.692-23.312-20.5-34.932l-.316.105v42.2H26.32V277.48Z",
    transform: "translate(-26.32 -277.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M60.407,329.545c-1.826-.351-3.721-.562-5.512-1.088a24,24,0,0,1-17.133-20.784c-.7-8.672,1.4-16.466,7.689-22.785a24.235,24.235,0,0,1,14.6-6.881c1.123-.14,2.212-.351,3.405-.527v5.512c-1.826.421-3.686.772-5.477,1.264-7.478,2.071-12.534,6.846-14.394,14.394-1.9,7.653.176,14.464,5.9,19.976A20.06,20.06,0,0,0,62.3,324.56a10.866,10.866,0,0,1,1.194.211v4.775H60.372Z",
    transform: "translate(2.085 -277.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M73.023,282.791a6.819,6.819,0,0,1-1.159.246H46.728a8.775,8.775,0,0,1-.878-.07V277.56c.492,0,.913-.07,1.334-.07H71.233a10.06,10.06,0,0,1,1.755.246v5.055Z",
    transform: "translate(22.716 -277.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M48.77,301.758V281.431c0-1.9.035-1.931,1.966-1.9h2.177a1.271,1.271,0,0,1,1.4,1.439v41.5c0,.983-.316,1.51-1.4,1.4a18.324,18.324,0,0,0-2.774,0c-1.018.07-1.369-.386-1.369-1.334V301.758Z",
    transform: "translate(30.047 -272.338)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.b17569fc594df49112e7d306bc4a8a11.svg";
export { ForwardRef as ReactComponent };